import axios from "axios";

export interface WorkflowTransition {
  id: string;
  name: string;
  from: string | null;
  to: string;
  type: "INITIAL" | "GLOBAL" | "DIRECTED";
}

export interface WorkflowStatus {
  id: string;
  name: string;
  statusCategory: "TODO" | "IN_PROGRESS" | "DONE";
}

export interface Workflow {
  id: string;
  name: string;
  description: string;
  issueTypes: IssueType[];
  statuses: WorkflowStatus[];
  transitions: WorkflowTransition[];
}

export interface IssueType {
  id: string;
  name: string;
  iconUrl: string;
}

export interface JiraWorkflowScheme {
  id: string;
  name: string;
  description: string;
  workflows: Workflow[];
  isDefault?: boolean;
}

const fetchWorkflowSchemes = async (toolPackageType?: string) => {
  const params = new URLSearchParams();
  if (toolPackageType) {
    params.append('toolPackageType', toolPackageType);
  }
  
  const { data: result } = await axios.get<JiraWorkflowScheme[]>(
    `${window.configuration.apiUrl}api/Jira/templateWorkflowSchemes${params.toString() ? '?' + params.toString() : ''}`
  );

  return result;
};

let JiraWorkflowSchemes: JiraWorkflowScheme[];
export const getJiraWorkflowSchemes = async (toolPackageType?: string) => {
  if (JiraWorkflowSchemes && !toolPackageType)
    return JiraWorkflowSchemes;

  JiraWorkflowSchemes = await fetchWorkflowSchemes(toolPackageType);
  return JiraWorkflowSchemes;
};
